import ENV from "@ipru-common/config/environment/constant";

export const API_KEY = "API_KEY";
export const JWT_TOKEN = "JWT";
export const NON_MIDDLEWARE = "NON_MIDDLEWARE";
export const MIDDLEWARE = "MIDDLEWARE";
export const TD_QDATA = "TD_QDATA";

export const ApiName = {
  LEADWS: "LEADWS",
  PIN_CODE: "PIN_CODE",
  EMP_DETAIL: "EMP_DETAIL",
  FLOW: "FLOW",
  EXTCUSTAPI: "EXTCUSTAPI",
  FUND_PERFORMANCE: "FUND_PERFORMANCE",
  FUND_PRODUCT_PERFORMANCE: "FUND_PRODUCT_PERFORMANCE",
  TRACER: "TRACER",
  DROPOFF: "DROPOFF",
  PARTNER: "PARTNER",
  APP_NUMBER_GENERATION: "APP_NUMBER_GENERATION",
  ADHAR_OTP_GENERATE: "ADHAR_OTP_GENERATE",
  ADHAR_OTP_VERIFICATION: "ADHAR_OTP_VERIFICATION",
  DOWNLOAD: "DOWNLOAD",
  FETCH_PAN_CARD_DETAIL: "FETCH_PAN_CARD_DETAIL",
  UPDATE_SFTP_DETAILS: "UPDATE_SFTP_DETAILS",
  EXT_CUST_GEN_OTP: "EXT_CUST_GEN_OTP",
  EXT_CUST_VERIFY_OTP: "EXT_CUST_VERIFY_OTP",
  EXT_CUST_FETCH_DETAIL: "EXT_CUST_FETCH_DETAIL",
  ADHAR_VERIFICATION: "APP_NUMBER_GENERATION",
  QUOTE: "QUOTE",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  AUTH_TOKEN: "AUTH_TOKEN",
  JWT_TOKEN: "JWT_TOKEN",
  BANK_IFSC: "BANK_IFSC",
  JOINTLIFE: "JOINTLIFE",
  // BANK_IFSC: "BANK_IFSC"
  EXPERIAN: "EXPERIAN",
  PENNY_DROP: "PENNY_DROP",
  FEEDBACK_FORM: "FEEDBACK_FORM",
  // VERIFY_OTC_DETAILS: "VERIFY_OTC_DETAILS",
  IIB: "IIB",
  OTP_TSA: "OTP_TSA",
  VERIFY_OTP_TSA: "VERIFY_OTP_TSA",
  OTC_GENERATE_OTP: "OTC_GENERATE_OTP",
  OTC_VERIFY_OTP: "OTC_VERIFY_OTP",
  OTC_GENERATE_EMAIL_OTP: "OTC_GENERATE_EMAIL_OTP",
  OTC_VERIFY_EMAIL_OTP: "OTC_VERIFY_EMAIL_OTP",
  // QUOTE_UAT: "QUOTE_UAT",
  PROMO_CODE_DISCOUNT: "PROMO_CODE_DISCOUNT",
  MEDICALBREDECISION: "MEDICALBREDECISION",
  DOWNLOADDOCUMENTAPI: "DOWNLOADDOCUMENTAPI",
  MEDICALPINCODE: "MEDICALPINCODE",
  ACCOUNTAGGREGATOR: "ACCOUNTAGGREGATOR",
  ELIGIBILITY: "ELIGIBILITY",
  TUMEDICALAPPOINTMENT: "TUMEDICALAPPOINTMENT",
  MEDICALSAVEAPPOINTMENT: "MEDICALSAVEAPPOINTMENT",
  WEGA: "WEGA",
  FETCH_PAYMENT_PAGE_URL: "FETCH_PAYMENT_PAGE_URL",
  WEBHOOK: "WEBHOOK",
};

// const ENV = process.env;

const MIDDLEWARE_MID_URL = "/v1/bol/middleware";

const ApiEndpoints = {
  [ApiName.LEADWS]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/leadws",
      authType: API_KEY,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/LEADWS`,
    },
  },
  [ApiName.PIN_CODE]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/pincodeService",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/PINCODEAPI`,
    },
  },
  [ApiName.EXTCUSTAPI]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/v1/adw/apis/client/enquiry`,
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/EXTCUSTAPI`,
    },
  },
  [ApiName.EXT_CUST_GEN_OTP]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/partner/webservices/generate/otp`,
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/EXTCUSTGENERATEOTP`,
    },
  },
  [ApiName.EXT_CUST_VERIFY_OTP]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/partner/webservices/encrypted/validateOTPandGetClientDetailsWS`,
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/EXTCUSTVALIDATEOTP`,
    },
  },
  [ApiName.EXT_CUST_FETCH_DETAIL]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/partner/webservices/encrypted/getClientDetails`,
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/EXTCUSTGETDETAILS`,
    },
  },
  [ApiName.TRACER]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/ipruapi/api/tracer`,
      authType: API_KEY,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/TRACER`,
    },
  },
  [ApiName.DOWNLOAD]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/v2/quote/json/ebidigital/pdf`,
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/QUOTEPDFAPI`,
    },
  },

  [ApiName.EMP_DETAIL]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/v1/ldap/authentication/employee/details",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/GROUPEMPLOYEE`,
    },
  },
  [ApiName.FLOW]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/pasa/process/flow",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/PASA`,
    },
  },
  [ApiName.DROPOFF]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/ipruapi/auth/comm/dropoff",
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/DROPOFFAPI`,
    },
  },
  [ApiName.JWT_TOKEN]: {
    endpoint: "/v1/oauth/jwt",
  },
  [ApiName.AUTH_TOKEN]: {
    endpoint: `${MIDDLEWARE_MID_URL}/generate/token`,
  },
  [ApiName.PARTNER]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/v1/partnerintegrator",
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/PARTNERINTEGRATION`,
    },
  },
  [ApiName.ACCESS_TOKEN]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/ipruapi/oauth/token`,
      headers: {
        Authorization: `Basic ${ENV().REACT_APP_ATAAK}`,
        "x-api-key": ENV().REACT_APP_ATHXAK,
      },
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/OAUTHTOKEN`,
    },
  },
  [ApiName.APP_NUMBER_GENERATION]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/pi/appnumber/generation`,
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/APPNOGENERATION`,
    },
  },
  [ApiName.ADHAR_OTP_GENERATE]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/buy/PartnerWebServices`,
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/EKYCOG`,
    },
  },
  [ApiName.ADHAR_OTP_VERIFICATION]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/buy/PartnerWebServices`,
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/EKYCOV`,
    },
  },
  [ApiName.FETCH_PAN_CARD_DETAIL]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/ckyc/search/service`,
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/CKYC`,
    },
  },
  [ApiName.FUND_PERFORMANCE]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/buy/funds-by-product.htm",
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/FUNDSBYPRODUCT`,
    },
  },
  [ApiName.FUND_PRODUCT_PERFORMANCE]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/buy/funds-product-performance.htm",
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/FUNDPERFORMANCE`,
    },
  },
  [ApiName.UPDATE_SFTP_DETAILS]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/InstaWebServices/rest/instaDocUpload/UpdateSFTPDetails",
      // endpoint: "/v1/insta-web-service/bol/docUpload",
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/UPLOADDOCUMENT`,
    },
  },
  [ApiName.QUOTE]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/quote/preprod/service/json`,
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/QUOTEAPI`,
    },
  },
  [ApiName.BANK_IFSC]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/getBankDetailsFromIFSC",
      authType: JWT_TOKEN,
      BASE: ENV().REACT_APP_APB,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/IFSC`,
    },
  },
  [ApiName.EXPERIAN]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/experianservice/bol/encrypted/json",
      authType: JWT_TOKEN,
      BASE: ENV().REACT_APP_BD,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/EXPERIANAPI`,
    },
  },
  [ApiName.OTP_TSA]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/generate-otp",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/GENERATEOTP`,
    },
  },
  [ApiName.VERIFY_OTP_TSA]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/validate-otp",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/VALIDATEOTP`,
    },
  },
  [ApiName.PENNY_DROP]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/bol-api/pennydrop",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/PENNYDROP`,
    },
  },
  [ApiName.FEEDBACK_FORM]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/feedback/form",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/FEEDBACK_FORM`,
    },
  },
  [ApiName.IIB]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/iib-service",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/IIB`,
    },
  },
  [ApiName.OTC_GENERATE_OTP]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/sms/generate-otp",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/OTCSMSGENERATEOTP`,
    },
  },
  [ApiName.OTC_VERIFY_OTP]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/sms/verify-otp",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/OTCSMSVERIFYOTP`,
    },
  },
  [ApiName.OTC_GENERATE_EMAIL_OTP]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/email/generate-otp",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/OTCEMAILGENERATEOTP`,
    },
  },
  [ApiName.OTC_VERIFY_EMAIL_OTP]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/email/verify-otp",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/OTCEMAILVERIFYOTP`,
    },
  },
  [ApiName.PROMO_CODE_DISCOUNT]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/partner/webservices/ips/promo-disc",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/PROMOCODE`,
    },
  },
  [ApiName.ELIGIBILITY]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/v3/api/quote/calculate/eligibility",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/ELIGIBILITY`,
    },
  },
  [ApiName.MEDICALBREDECISION]: {
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/MEDICALBREDECISION`,
    },
  },
  [ApiName.DOWNLOADDOCUMENTAPI]: {
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/DOWNLOADDOCUMENTAPI`,
    },
  },
  [ApiName.MEDICALPINCODE]: {
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/MEDICALPINCODE`,
    },
  },
  [ApiName.ACCOUNTAGGREGATOR]: {
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/ACCOUNTAGGREGATOR`,
    },
  },
  [ApiName.TUMEDICALAPPOINTMENT]: {
    [NON_MIDDLEWARE]: {
      endpoint: `/partner/webservices/tuservice`,
      authType: JWT_TOKEN,
    },
  },
  [ApiName.MEDICALSAVEAPPOINTMENT]: {
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/MEDICALSAVEAPPOINTMENT`,
    },
  },
  [ApiName.WEGA]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/adw/realtime/v1/existing/customer/wega",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/WEGA`,
    },
  },
  [ApiName.FETCH_PAYMENT_PAGE_URL]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/InstaWebServices/rest/instaPayment/fetchPaymentPageUrl",
      noAuth: true,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/FETCH_PAYMENT_PAGE_URL`,
    },
  },
  [ApiName.WEBHOOK]: {
    [NON_MIDDLEWARE]: {
      endpoint: "/tata-api/partner/webhook",
      authType: JWT_TOKEN,
    },
    [MIDDLEWARE]: {
      endpoint: `${MIDDLEWARE_MID_URL}/WEBHOOK`,
    },
  },
};

export default ApiEndpoints;
